module.exports = __webpack_public_path__ + "static/media/sledding.37f01098.svg";